import React, { useCallback } from "react";
import {
  CombinatorSelectorProps,
  FullCombinator,
  OptionGroup,
} from "react-querybuilder";
import { Text, HStack, Select } from "@chakra-ui/react";
import colors from "app/colors";

const QueryCombinatorSelector: React.FC<CombinatorSelectorProps> = ({
  handleOnChange,
  options,
  className,
  value,
}) => {
  const isOptionGroup = useCallback(
    (
      option: FullCombinator | OptionGroup<FullCombinator>,
    ): option is OptionGroup<FullCombinator> => "options" in option,
    [],
  );

  return (
    <HStack className={className}>
      <Text fontWeight={600} fontSize={16} color={colors.blackSecondary}>
        Automatically include users who match
      </Text>
      <Select
        onChange={(e) => handleOnChange(e.target.value)}
        value={value}
        w={140}
        size="xs"
        fontSize={14}
      >
        {options.map((option) => {
          if (isOptionGroup(option)) {
            return (
              <optgroup key={option.label} label={option.label}>
                {option.options.map((subOption) => (
                  <option
                    key={subOption.name}
                    value={subOption.name}
                    style={{ fontSize: "14px" }}
                  >
                    {subOption.label}
                  </option>
                ))}
              </optgroup>
            );
          }
          return (
            <option
              key={option.name}
              value={option.name}
              style={{ fontSize: "14px" }}
            >
              {option.label}
            </option>
          );
        })}
      </Select>
      <Text fontWeight={600} fontSize={16} color={colors.blackSecondary}>
        below:
      </Text>
    </HStack>
  );
};

export default QueryCombinatorSelector;
